export const TAB_UNDERLINE_HEIGHT_PX = 2;

// very specific transition.  spec was to copy that of MUI's tabs
export const TAB_TRANSITION = 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)';

export const TAB_PANEL_TRANSITION_DURATION_MILLIS = 300;
export const TAB_PANEL_CLASSNAME = 'TabPanel';
